import AnalysisType from './AnalysisType'

/**
 * @type {Array.<AnalysisType>}
 * @const
 */

export const SW_ANALYSIS = [
  AnalysisType.SW_OVERVIEW,
  AnalysisType.SW_SUMMARY,
  AnalysisType.SW_NEW_SUMMARY,
  AnalysisType.SW_SENTIMENT,
  AnalysisType.SW_LIKES_AND_DISLIKES,
  AnalysisType.SW_AUTHOR,
  AnalysisType.SW_DEMOGRAPHIC,
  AnalysisType.SW_SOURCE,
  AnalysisType.SW_DOMAIN,
  AnalysisType.SW_STREAM,
  AnalysisType.SW_TOP_TWEET,
  AnalysisType.SW_MEDIA,
  AnalysisType.SW_TOP_LINKS,
  AnalysisType.SW_POST_ACTIVITY,
  AnalysisType.SW_LANGUAGE,
  AnalysisType.SW_TAGS,
  AnalysisType.SW_CHANNEL_COMPARISON
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const AM_ANALYSIS = [
  AnalysisType.AM_SUMMARY,
  AnalysisType.AM_NEW_SUMMARY,
  AnalysisType.AM_SENTIMENT,
  AnalysisType.AM_LIKES_AND_DISLIKES,
  AnalysisType.AM_AUTHOR,
  AnalysisType.AM_DEMOGRAPHIC,
  AnalysisType.AM_STREAM,
  AnalysisType.AM_MEDIA,
  AnalysisType.AM_TOP_LINKS,
  AnalysisType.AM_POST_ACTIVITY,
  AnalysisType.AM_LANGUAGE
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_YOUTUBES = [AnalysisType.YT_SUMMARY, AnalysisType.YT_STREAM]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_GEOGRAPHIES = [AnalysisType.SW_GEOGRAPHY, AnalysisType.SW_GEO_TAGGED]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const AM_GEOGRAPHIES = [AnalysisType.AM_GEOGRAPHY, AnalysisType.AM_GEO_TAGGED]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_COMPARISONS = [
  AnalysisType.SW_TOPIC_COMPARISON,
  AnalysisType.SW_CROSSTAB,
  AnalysisType.SW_TIMELINE_COMPARISON,
  AnalysisType.SW_BRAND_PASSION_INDEX,
  AnalysisType.SW_SIDE_BY_SIDE
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const AM_COMPARISONS = [
  AnalysisType.AM_TOPIC_COMPARISON,
  AnalysisType.AM_CROSSTAB,
  AnalysisType.AM_TIMELINE_COMPARISON
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_EXPLORATIONS = [AnalysisType.SW_ALL_IN_ONE]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const AM_EXPLORATIONS = [AnalysisType.AM_ALL_IN_ONE]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_CONVERSATIONS = [
  AnalysisType.SW_EXPLORE,
  AnalysisType.SW_CONVERSATION,
  AnalysisType.SW_BENCHMARK,
  AnalysisType.SW_TRENDING
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const AM_CONVERSATIONS = [
  AnalysisType.AM_CONVERSATION,
  AnalysisType.AM_BENCHMARK,
  AnalysisType.AM_TRENDING,
  AnalysisType.AM_THINGS
]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const SW_IMAGES = [AnalysisType.SW_PHOTO_CONCEPT]

/**
 * @type {Array.<AnalysisType>}
 * @const
 */
export const APPROXIMATE_WARNING = [
  AnalysisType.SW_AUTHOR,
  AnalysisType.SW_GEOGRAPHY,
  AnalysisType.SW_DOMAIN,
  AnalysisType.AM_GEOGRAPHY,
  AnalysisType.AM_AUTHOR
]

export const SW = [
  ...SW_ANALYSIS,
  ...SW_YOUTUBES,
  ...SW_GEOGRAPHIES,
  ...SW_COMPARISONS,
  ...SW_EXPLORATIONS,
  ...SW_CONVERSATIONS,
  ...SW_IMAGES,
  // TODO: PRO does not exists in AnalysisType
  // @ts-ignore
  AnalysisType.PRO
]

export const AM = [
  ...AM_ANALYSIS,
  ...AM_GEOGRAPHIES,
  ...AM_COMPARISONS,
  ...AM_EXPLORATIONS,
  ...AM_CONVERSATIONS
]
